import DrawerHeader, {
	type DrawerHeaderProps,
} from '@liquidweb-dev/undercurrent/DrawerHeader';

/** Header for DrawerAddOn */
const DrawerAddOnHeader = (props: DrawerHeaderProps) => {
	return <DrawerHeader {...props}>Checkout</DrawerHeader>;
};

export default DrawerAddOnHeader;
